import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-lock",
  "use": "svgIcon-lock-usage",
  "viewBox": "4.75 2.5 71 71",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"4.75 2.5 71 71\" id=\"svgIcon-lock\"><g fill=\"currentColor\"><path d=\"m40 22.7c-4.4 0-7.9 3.5-7.9 7.9v4.8h15.8v-4.8c0-4.4-3.5-7.9-7.9-7.9\" /><path d=\"m40 2.5c-19.6 0-35.5 15.9-35.5 35.5 0 19.6 15.9 35.5 35.5 35.5 19.6 0 35.5-15.9 35.5-35.5 0-19.6-15.9-35.5-35.5-35.5m15.5 53h-31.7v-20.6h3.1v-4.8c0-7 5.7-12.7 12.7-12.7 7 0 12.7 5.7 12.7 12.7v4.8h3.2v20.6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol